<template>
  <div class="custom-checkbox">
    <label class="switch">
      <input
        autocomplete="off"
        type="checkbox"
        :checked="checked"
        :disabled="isDisabled"
        @click="toggle"
      />
      <span class="slider">
        <span style="text-align:center;">On</span>
        <span style="text-align:center;">Off</span>
      </span>
    </label>
  </div>
</template>

<script>
export default {
   
  props: {
    isDisabled: Boolean,
    isChecked: Boolean,
  },
  data() {
    return {
      checked: false
    };
  },
  mounted() {
    this.checked = this.isChecked
  },
  methods: {
    toggle() {
      this.$emit("toggle");
    }
  },
  watch: {
    isChecked: function (newVal, oldVal) {
      this.checked = newVal
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
// @import "@/style/components/modals";
$slider-padding: 3px;
$slider-size: 24px;
$slider-width: $slider-size * 2 + $slider-padding;
$slider-border: 2px;
$slider-extra-width: 12px;

.custom-checkbox {
  .switch {
    position: relative;
    display: inline-block;
    width: $slider-width + $slider-extra-width;
    height: $slider-size;
    input {
      opacity: 0;
      width: 0;
      height: 0;

      &:checked + .slider {
        background-color: $background-color;
        border-color: $primary-color;
        color: $primary-color;
        &:after {
          background-color: $primary-color;
          transform: translateX(
            $slider-size + $slider-padding + $slider-extra-width/2
          );
        }
      }

      &:checked &:disabled + .slider {
        cursor: default;
        background-color: $light-grey;
        color: $grey;
        border: $slider-border solid $grey;
        &:after {
          background-color: $grey;
          transform: translateX(
            $slider-size + $slider-padding + $slider-extra-width/2
          );
        }
      }

      &:disabled + .slider {
        cursor: default;
        background-color: $light-grey;
        color: $grey;
        border: $slider-border solid $grey;
      }

      &:focus + .slider {
        box-shadow: 0 0 1px #2196f3;
      }
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #EFEFEF;
      border: $slider-border solid #C6C6C6;
      color: #707070;
      font-weight: 500;
      border-radius: 6px;
      -webkit-transition: 0.4s;
      transition: 0.4s;

      display: flex;
      justify-content: space-around;
      align-items: center;
      span {
        font-size: 11px;
        font-weight: 600;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
      }
      &:after {
        position: absolute;
        content: "";
        height: $slider-size - $slider-border * 2;
        width: $slider-size - $slider-border * 2 + $slider-extra-width / 2;
        left: 0;
        top: 0;
        background-color: #707070;
        border-radius: 4px;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
    }
  }
}
</style>
